<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-card>
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-textarea v-model="info" outlined hide-details="auto" label="سياسة الخصوصية" :disabled="loading"></v-textarea>
						</v-col>

						<v-col cols="12" class="text-center">
							<v-btn :loading="loading" color="primary" @click="updateInfo">
								تحديث البيانات
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					disabled: false,
					to: { name: "dashboard-home" }
				},
				{ 
					text: "سياسة الخصوصية",
					disabled: true 
				}
			],
			loading: true,
			info: null,
		};
	},
	mounted() {
		this.getInfo();
	},
	methods: {
		getInfo() {
			client
				.get("/api/system/privacyPolicy")
				.then(response => {
					this.info = response.data.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateInfo() {
			this.loading = true;
			var data = {
				privacyPolicy: this.info
			};

			clientNotifier
				.post("/api/system/updatePrivacyPolicy", data)
				.finally(() => {
					this.loading = false;
				});
		},
	}
};
</script>